export const orderStatus = [
  {
    code: 1,
    label: 'received',
    labelIcon: 'ic:round-fastfood',
    group: 'active',
    step: 'receive',
    stepAction: 'orderReceived',
    action: 'prepare',
    actionIcon: 'mdi:delete-variant' 
  },
  {
    code: 2,
    label: 'preparing',
    labelIcon: 'eva:clock-fill',
    group: 'active',
    step: 'startPrep',
    stepAction: 'startedPreparation',
    action: `setReady`,
    actionIcon: 'eva:bell-fill' 
  },
  {
    code: 3,
    label: 'ready',
    labelIcon: 'eva:bell-fill',
    group: 'active',
    step: 'finishPrep',
    stepAction: 'finishedPreparation',
    action: 'deliver',
    actionIcon: 'mdi:glass-cocktail' 
  },
  {
    code: 4,
    label: 'completed',
    labelIcon: 'eva:checkmark-circle-2-fill',
    group: 'inactive',
    step: 'complete',
    stepAction: 'orderDelivered',
    action: '',
    actionIcon: '' 
  },
  {
    code: 0,
    label: 'canceled',
    labelIcon: 'eva:close-circle-fill',
    group: 'canceled',
    step: 'cancel',
    stepAction: 'orderCanceled',
    action: '',
    actionIcon: '' 
  },
];

export const inactiveOrders = orderStatus
  .filter(status => status.group === 'inactive' || status.group === 'canceled')
  .map(status => status.code.toString());

export const completedOrders = orderStatus
  .filter(status => status.group === 'inactive')
  .map(status => status.code.toString());

export const activeOrders = orderStatus
  .filter(status => status.group === 'active')
  .map(status => status.code.toString());

export const allOrders = orderStatus
  .map(status => status.code.toString());